import { createFileRoute } from "@tanstack/react-router";
import { supporters } from "@/data/supporters";
import { ProfilePage, profileHead, ProfileError } from "@/pages/ProfilePage";

const supporter = supporters.find((s) => s.id === "toke")!;

export const Route = createFileRoute("/de/moed-toke")({
  head: () => profileHead(supporter, "de"),
  errorComponent: ({ error }) => <ProfileError locale="de" error={error} />,
  component: () => <ProfilePage supporter={supporter} locale="de" />,
});
